import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form } from 'antd';
import dayjs from 'dayjs';
import { DatePicker } from 'ui/styled';
import { DATE_FORMAT_YMD } from 'utils/helpers/dateHelper';
import { requiredMessage } from '../helpers/formHelpers';
var DateField = function (_a) {
    var onInputChange = _a.onInputChange, id = _a.id, placeholder = _a.placeholder, required = _a.required, isTicketSurvey = _a.isTicketSurvey;
    var handleChange = function (date) {
        var value = dayjs.isDayjs(date) ? date.format(DATE_FORMAT_YMD) : '';
        onInputChange(value);
    };
    return (_jsx(Form.Item, { name: id, rules: [
            {
                required: isTicketSurvey && required,
                message: requiredMessage
            }
        ], getValueProps: function (value) { return ({
            value: value ? dayjs(value) : null
        }); }, children: _jsx(DatePicker, { format: DATE_FORMAT_YMD, onChange: handleChange, placeholder: placeholder || 'Select date', "data-test": "DatePicker_".concat(id), style: { width: '100%' } }) }));
};
export default DateField;
